import gsap, { Power1 } from "gsap";

import { GetBy } from "../_app/cuchillo/core/Element";

export default class Preloader {
    _container;
    _progress;
    _logo;

    static init() {
        this._container = GetBy.id('Preloader');
        this._progress = GetBy.class('__progress', this._container)[0];
        this._logo = GetBy.tag('svg', this._container);

        gsap.to(this._logo, {
            opacity: 1,
            delay: .4,
            duration: .6
        });
    }

    static update(__progress) {
        gsap.killTweensOf(this._progress);
        gsap.to(this._progress, {
            scaleX: __progress,
            ease: Power1.easeOut,
            duration: .1
        });
    }

    static hide(__call) {
        gsap.killTweensOf(this._progress);
        gsap.to(this._progress, {
            scaleX: 1,
            ease: Power1.easeOut,
            duration: .6,
            onComplete: () => {
                this._progress.style.transformOrigin = 'right center';
            }
        });
        gsap.to(this._logo, {
            opacity: 0,
            delay: 1.2,
            duration: .3
        });
        gsap.to(this._progress, {
            scaleX: 0,
            ease: Power1.easeOut,
            delay: 1.2,
            duration: .4
        });
        gsap.to(this._container, {
            duration: .5,
            opacity: 0,
            delay: 1.6,
            onComplete: () => {
                this._progress.style.transformOrigin = 'center left';
                this._container.style.display = "none";
                if (__call) __call();
            }
        });
    }
}
